<template>
  <div class="customVideoHls" :style="{width: width,height: height}">
    <video muted  id="videobox" class="video-js vjs-default-skin vjs-big-play-centered " :webkit-playsinline="true"
      webview.allowsInlineMediaPlayback=YES :x5-video-player-fullscreen="true"  :playsinline="true"
      style="height: 100%;width: 100%;object-fit:fill;" ref="videoRef">
      <source id="sourceBox"  type="video/mp4">
      <p class="vjs-no-js">不支持播放</p>
    </video>
  </div>
</template>
<style>
</style>
<script>
  import 'video.js/dist/video-js.css'
  import videojs from 'video.js'
  import 'videojs-contrib-hls'
  import fwUtil from 'framework-util'
  import {getDataService} from '../../api/chart/chart/index.js'
  export default {
    props: {
      width: {
        type: String,
        default: '300px'
      },
      height: {
        type: String,
        default: '30px'
      },
      chartConfig: {
        type: Object,
        default: function() {
          return {
            isSync:'0',//是否是动态URL，主要是海康3.0版本，如果视频没有播放，则其URL的有效期只有5分钟 0是 1否
            videoSrc: '',
            syncVideoCode:'',//动态视频编码
            syncVideoUrl:'',//动态获取视频编码地址
            taskTime:1000,//动态获取URL周期，单位毫秒
            type:'application/x-mpegURL'
          }
        }
      }
    },
    watch: {
      chartConfig: {
        handler(newValue, oldValue) {
          let that=this
          console.info("that.chartConfig.videoSrc==="+that.chartConfig.videoSrc)
          let str = this.chartConfig.videoSrc
           console.info(that.chartConfig)
        if(this.chartConfig.isSync==='1' && this.chartConfig.syncVideoUrl){
              getDataService(this.chartConfig.syncVideoUrl,{code:this.chartConfig.syncVideoCode}).then((res)=>{
                console.info("that.chartConfig.videoSrc2===单视频调用服务启动")
                this.chartConfig.videoSrc=res.videoSrc
                that.getPlay()
              })
            }else{
                  that.getPlay()
            }
          // let  p=this.player
          // this.player.src(newValue.videoSrc)
          // this.player.load(newValue.videoSrc)
          // this.player.play()
          // setTimeout(function() {
          //      p.play()

          //  }, 200);
        },
        deep: true
      },
    },
    mounted() {
      let that=this
      console.info("that.chartConfig.videoSrc1==="+that.chartConfig.videoSrc)
      console.info(that.chartConfig)
      if(this.chartConfig.isSync==='1' && this.chartConfig.syncVideoUrl){
        getDataService(this.chartConfig.syncVideoUrl,{code:this.chartConfig.syncVideoCode}).then((res)=>{
          console.info("that.chartConfig.videoSrc2===单视频调用服务启动")
          this.chartConfig.videoSrc=res.videoSrc
          that.getPlay()
        })
      }else{
        this.$nextTick(() => {
            that.getPlay()
        });
      }


    },
    beforeDestroy() {
      if(this.player){
        this.player.dispose()
        this.player=null
      }
    },
    computed: {

      imageUrl() {
        if (this.chartConfig && this.chartConfig.uploadUrl && this.chartConfig.authorization && this.chartConfig.imageId) {
          return this.chartConfig.uploadUrl + '/upload/preView?Authorization=' + this.chartConfig.authorization +
            '&id=' + this.chartConfig.imageId
        }
        return ""
      }
    },
    data() {
      return {
        player: null
      }
    },
    methods: {
      getPlay() {
        let that=this
        if (this.player == null) {
           this.player = videojs(this.$refs.videoRef, {
             muted: true,
             controls: true,
             preload: 'auto',
             loop : true,
             autoplay: true,
             playsinline: true,
             allowsInlineMediaPlayback: 'YES',
             width: this.width,
             height: this.height
           });
           if(this.chartConfig.videoSrc){
             this.player.src(this.chartConfig.videoSrc)
             this.player.play()
             }
              this.player.on("error", function(){
                     console.log("加载错误")
                     // if(that.chartConfig.isSync==='0' && that.chartConfig.syncVideoUrl){
                     //   getDataService(that.chartConfig.syncVideoUrl,{code:that.chartConfig.syncVideoCode}).then((res)=>{
                     //     that.chartConfig.videoSrc=res.videoSrc
                     //   })
                     // }
                 });
            this.player.on("stalled",function(){
                   console.log("网速异常");
                   // if(that.chartConfig.isSync==='0' && that.chartConfig.syncVideoUrl){
                   //   getDataService(that.chartConfig.syncVideoUrl,{code:that.chartConfig.syncVideoCode}).then((res)=>{
                   //     that.chartConfig.videoSrc=res.videoSrc
                   //   })
                   // }
             })
        }else{
          if(this.chartConfig.videoSrc){
            this.player.src(this.chartConfig.videoSrc)
            this.player.load(this.chartConfig.videoSrc)
            this.player.play()
            }
        }

        //this.player.options.flash.swf = 'video-js-fixed.swf';

       },
      videoSrc() {
        if (this.chartConfig && this.chartConfig.videoSrc) {
          return this.chartConfig.videoSrc
        }
        return ""
      }
    }
  }
</script>

<style>

  .customVideoHls .video-js.vjs-16-9{
    padding-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/images/VideoHls.vue